import { onClickExchange } from 'src/component/logic/tip-merchant/goods/detail';


export function exchangeAwards(water, gameInfo) {
  if (water.isExpired || water.isUsed) return;
  const newInfo = {
    ...(water || {}),
    ...(gameInfo || {}),
    originWater: {
      ...(water.originWater),
      ...(gameInfo || {}),
      role: {
        ...(water.role || {}),
        ...(gameInfo || {}),
        roleIdx: gameInfo.roleidx,
      },
    },
    role: {
      ...(water.role || {}),
      ...(gameInfo || {}),
      // '384733382ab7acdfb857f11f964d4dd9'
      roleIdx: gameInfo.roleidx,
    },
  };
  console.log('[onExchange]', newInfo);
  return onClickExchange.call(
    newInfo,
    '/PromoPlatform.Game.exchange.exchange/Exchange',
  );
}


export function batchExchangeAwards(waterList, gameInfo) {
  return new Promise((resolve, reject) => {
    const promise = waterList.map(water => exchangeAwards(water, gameInfo));
    Promise.all(promise).then((resp = []) => {
      const hasFailOne = resp.find(item => !!item.ret || !!item.r);
      if (hasFailOne) {
        reject(resp);
      } else {
        resolve(resp);
      }
    })
      .catch((err) => {
        reject(err);
      });
  });
}
